import * as actionTypes from './actionTypes'
import { fromJS } from 'immutable'

const defaultState = fromJS({
    msg: 'this.is.home.redux.store.msg',
    headerData: {
        title: "",
        type: 0,
        path:''
    }
})



export default (state = defaultState, action) => {
    switch (action.type) {
        case actionTypes.SET_HEADER_DATA:
            return state.set('headerData', action.data)

        default:
            return state;
    }
}
